import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { adminapi, donorapi } from "../../ApiNames";

export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchImageDataSuccess=(imgdata:any) =>({
    type: 'FETCH_IMAGE_DATA_SUCCESS',
    payload: imgdata,
});
export const fetchdocDataSuccess=(docdata:any) =>({
    type: 'FETCH_DOC_DATA_SUCCESS',
    payload: docdata,
});
export const fetchUpdateDataSuccess=(updatedata:any) =>({
    type: 'FETCH_UPDATE_DATA_SUCCESS',
    payload: updatedata,
});
export const fetchCountryDataSuccess=(countrydata:any) =>({
    type: 'FETCH_COUNTRY_DATA_SUCCESS',
    payload: countrydata,
});
export const fetchDataViewSuccess=(dataview:any) =>({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: dataview,
});
export const fetchEditDataSuccess=(regdata:any) =>({
    type: 'FETCH_VIEW_DATA__register_SUCCESS',
    payload: regdata,
});
export const fetchHeaderdata=(headerdata:any) =>({
    type: 'FETCH_HEADER_DATA',
    payload: headerdata,
});


export const fetchDonordata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = donorapi.donorprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
// Countrydata
export const fetchcoundata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = adminapi.adcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchCountryDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//Attachments data
export const fetchDocdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,q:5};
            const apiname = donorapi.document;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdocDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//To upload image
export const UploadImageData = (fileToUpload: any, uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const apiname = donorapi.dprofileimage;
            if (uid == null) {
                console.error('Error: uid is null or undefined');
                return;
            }
            // Create FormData and append the file
            const formData = new FormData();
            const fileName = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload', fileToUpload, fileName);
            const response = await LoginService.uploadimage(apiname, formData);
            dispatch(fetchImageDataSuccess(response));
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };
};

//Edit Data
export const EditData = (firstname:any,lastname:any,email:any,gender:any,phone:any,idcard_no:any,address:any,city:any,state:any,pincode:any,country:any,paypal:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {firstName:firstname,lastName:lastname,email:email,gender:gender,phone:phone,idcard_no:idcard_no,address:address,city:city,state:state,pincode:pincode,country:country,paypalaccount:paypal,uid:uid};
            const apiname = donorapi.dprofiledata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchUpdateDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//Edit Data
export const RegisterData = (firstname:any,lastname:any,email:any,gender:any,phone:any,idcard_no:any,address:any,city:any,state:any,pincode:any,country:any,paypal:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {firstname:firstname,lastName:lastname,email:email,gender:gender,phone:phone,idcard_no:idcard_no,address:address,city:city,state:state,pincode:pincode,country:country,paypalaccount:paypal,uid:uid,q:1};
            const apiname = donorapi.dregdata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchEditDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


//T0 view document
export const viewdata = (did:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did:did,q:4};
            const apiname = donorapi.deletedocument;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const Headerdata = (userid:any,usertype:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:userid,usertype:usertype};
            const apiname = donorapi.headerprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchHeaderdata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

